// extracted by mini-css-extract-plugin
module.exports = {"root":"Line_root__u7lgd","secondary":"Line_secondary__Shn6B"};